module.exports = __webpack_public_path__ + "media/images/top/img_pickup_harukiya-25fb42c5d642b7d3f28cb97c701f38a4.webp";